import { twMerge } from "tailwind-merge";
import LoadingPop from "components/popup/LoadingPop";

export type DataListProps = {
    [key: string]: any;
};

type TableProps = {
    thead: {
        title: string;
        width: string;
        content?: (row: DataListProps, rowIndex: number) => void;
        key?: string;
        className?: string | ((row: DataListProps, rowIndex: number) => string);
        onClick?: (value: any, row: DataListProps, rowIndex: number) => void;
    }[];
    tbody: DataListProps[];
    className?: string;
    uniqueKeyName?: string;
    isLoading: boolean;
    trClassName?: string;
    trClick?: (row: DataListProps) => void;
};

export default function ConsoleTable({ thead, tbody, className, uniqueKeyName, isLoading, trClassName, trClick }: TableProps) {
    const figureStyle = twMerge(`overflow-x-auto min-h-[720px]`, className);
    const trStyle = twMerge("border-b border-[#dddddd]", trClassName);

    return (
        <figure className={figureStyle}>
            <table className="min-w-[800px] w-full border-b border-b-[1px] border-b-[#dddddd] table-fixed">
                <colgroup>
                    {thead.map((th, index) => {
                        return <col key={index} width={th.width} />;
                    })}
                </colgroup>

                <thead>
                    <tr className="border-b border-b-[1px] border-b-[#dddddd] bg-[#FBFBFC]">
                        {thead.map((th, index) => {
                            return (
                                <th key={index} scope="col" className="font-[500] py-[22px] text-[#666666] relative">
                                    <span className="txt">{th.title}</span>
                                </th>
                            );
                        })}
                    </tr>
                </thead>
                <tbody>
                    {tbody.length === 0 ? (
                        <tr>
                            <td colSpan={thead.length} className="text-center">
                                <div className="min-h-[650px] pt-[150px]">{isLoading ? <LoadingPop /> : "등록된 게시글이 없습니다."}</div>
                            </td>
                        </tr>
                    ) : (
                        <>
                            {tbody.map((tb, rowIndex) => (
                                <tr
                                    key={uniqueKeyName ? tb[uniqueKeyName] : rowIndex}
                                    className={trStyle}
                                    onClick={() => (trClick ? trClick(tb) : undefined)}
                                >
                                    {thead.map((th, idx) => {
                                        const tdClassName = typeof th.className === "function" ? th.className(tb, rowIndex) : th.className;

                                        return (
                                            <td key={idx} onClick={() => th.onClick?.(tb[th.key as keyof DataListProps], tb, rowIndex)}>
                                                <div
                                                    className={twMerge(
                                                        "px-2 min-h-[63px] flex items-center justify-center py-[13px]",
                                                        tdClassName,
                                                    )}
                                                >
                                                    {typeof th.content === "function"
                                                        ? th.content(tb, rowIndex)
                                                        : tb[th.key as keyof DataListProps]}
                                                </div>
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))}
                        </>
                    )}
                </tbody>
            </table>
        </figure>
    );
}
